import { LogOut } from 'lucide-react';

import {
  FONT_WEIGHTS,
  RADIUS_SCALE,
  SIZE_SCALE,
  SPACE_X_SCALE,
  SURFACE_PADDING,
  TYPE_SCALE,
  PADDING_Y,
  MARGIN_X,
} from '@/components/design-system/tokens';

interface LogoutButtonProps {
  onLogout: () => void;
  onClose: () => void;
  label: string;
}

export const LogoutButton = ({ onLogout, onClose, label }: LogoutButtonProps) => (
  <button
    onClick={() => {
      onLogout();
      onClose();
    }}
    className={`flex items-center ${SPACE_X_SCALE['3']} ${SURFACE_PADDING['3']} ${PADDING_Y['2.5']} ${MARGIN_X['1']} ${TYPE_SCALE.xs} text-destructive hover:bg-destructive/10 hover:text-destructive transition-colors w-full text-left ${RADIUS_SCALE.md} focus:outline-none focus:ring-2 focus:ring-destructive focus:ring-inset`}
    role="menuitem"
  >
    <LogOut className={`${SIZE_SCALE['4']} ${SIZE_SCALE['4']} text-destructive flex-shrink-0`} />
    <span className={`${FONT_WEIGHTS.light} truncate`}>{label}</span>
  </button>
);
